import type { GetStyles, Split, TypographyCode, TypographyStyledProps } from '@sds-system/types';

export const getTypographyStyles: GetStyles<TypographyStyledProps> = ({ theme, fontType }) => {
  const splitFontType = (fontType?.split('.') as Split<'.', TypographyCode>) || [];

  if (splitFontType.length === 2) {
    return {
      ...theme.typography[splitFontType[0]][splitFontType[1]],
    };
  }
  return {};
};
